import { IRemake, TVoiceMemo } from 'lib/types/clinic/projectTypes';
import { createStoreWithSetters } from './utils';

interface IStoreProps {
  pageType: string; // 페이지 타입
  projectId: string; // 프로젝트 id
  projectName: string; // 프로젝트 명
  dueDate: number | null; // 프로젝트 기한
  senderMemo: string; // 메모
  voiceMemoList: TVoiceMemo[]; // 음성기록
  manager: number | null; // 참여자 (클라이언트, 매니저, 파트너)
  remakeType: IRemake[] | null; // 리메이크 타입
  exocadVersion: number; // 엑소캐드 버전
  projectCode: string; // 프로젝트 코드
  teethTreatmentIdx: number | null; // 프로젝트 치아 DB정보
  stage: number | null; // 프로젝트 단계
  newDate: number | null; // 프로젝트 생성일 (프론트에서 안보내면 백엔드에서 자동생성)
  copyProjectCode: string | null; // 복사한 프로젝트 코드
  copyProjectOption: string[] | null; // 복사한 프로젝트 옵션
  patientName: string | null; // 환자명
  patientCodeIdx: number | null; // 환자코드인덱스
  isMultidie: number | null; // 멀티다이 여부
  isInfoOpen: boolean; // 프로젝트 정보 모달 오픈 여부
  isIndicationOpen: boolean; // 프로젝트 인디케이션 모달 오픈 여부
  isLibraryOpen: boolean; // 프로젝트 인디케이션 라이브러리 모달 오픈 여부
  isAgreementOpen: boolean; // 프로젝트 생성 약관동의 모달 오픈 여부
  isValidInfo: boolean; // 프로젝트 정보 유효성
  selectedSyncPartner: number | ''; // 파트너
  partnerName: string | null; // 파트너 명
}

export const useCreateProjectInfoStore = createStoreWithSetters<IStoreProps>(
  {
    pageType: '',
    projectId: '',
    projectName: '',
    dueDate: null,
    senderMemo: '',
    voiceMemoList: [],
    manager: null,
    remakeType: [],
    exocadVersion: 3,
    projectCode: '',
    teethTreatmentIdx: null,
    stage: null,
    newDate: null,
    copyProjectCode: '',
    copyProjectOption: null,
    patientName: null,
    patientCodeIdx: null,
    isMultidie: 0,
    isInfoOpen: false,
    isIndicationOpen: false,
    isLibraryOpen: false,
    isAgreementOpen: false,
    isValidInfo: false,
    selectedSyncPartner: '',
    partnerName: null,
  },
  'project_create_info',
);
